import { render, staticRenderFns } from "./CheckAnimate.vue?vue&type=template&id=c21b2c74&"
import script from "./CheckAnimate.vue?vue&type=script&lang=js&"
export * from "./CheckAnimate.vue?vue&type=script&lang=js&"
import style0 from "./CheckAnimate.vue?vue&type=style&index=0&id=c21b2c74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports